<template>
	<div class="flex items-center justify-center gap-2">
		<i-ph-detective-duotone class="text-primary size-10" />
		<h1 class="text-xl font-semibold text-black">
			Comprice.io
		</h1>
	</div>
</template>
